<ion-header>
    <ion-toolbar>
        <ion-title> {{ 'Color Picker' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button color="dark" fill="clear" (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-radio-group [value]="selectedColor" (ionChange)="changeColor($event)">
            <ion-item button *ngFor="let c of colors" lines="none" (click)="selectedColor = c.hexValue">
                <ion-radio slot="start" [value]="c.hexValue"></ion-radio>
                <ion-input type="text" readonly [ngStyle]="{ 'background-color': c.hexValue, 'color': c.hexValue }"></ion-input>
            </ion-item>
        </ion-radio-group>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-item>
            <ion-input required labelPlacement="stacked" type="text" [(ngModel)]="selectedColor" #color>
                <div slot="label">{{ 'Color hex value ' | translate }}<ion-text color="danger">*</ion-text></div>
            </ion-input>
            <ion-avatar slot="end">
                <div class="team-avatar" [ngStyle]="{ 'backgroundColor': color.value }"></div>
            </ion-avatar>
        </ion-item>
        <ion-button class="ion-margin" (click)="selectColor(color.value)" expand="block">
            {{ 'Select color' | translate }}
        </ion-button>
    </ion-toolbar>
</ion-footer>